import React, { Component } from "react"
import styled, { css } from "styled-components"
import { navigate } from "gatsby"
import {  Modal, ModalBody, Row, Col } from "reactstrap"
import { GatsbyImage } from "gatsby-plugin-image"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faFacebookF, faTwitter, faInstagram } from "@fortawesome/free-brands-svg-icons"
import { faGlobe, faTimes } from "@fortawesome/free-solid-svg-icons"
import { media } from "utils/Media"
import Text from "components/shared/Text"
import WPLink from "components/shared/WPLink"
import CarouselItemBg from "components/shared/CarouselItemBg"
import MenuDishes from "components/shared/MenuDishes"

const ListingItemStyled = styled.div`
    position: relative;
    line-height: 0;
    filter: drop-shadow(0px 0px 10px rgba(0, 0, 0, 0.15));
    padding: 1rem;
    background-color: white;
    margin-bottom: .5rem;

    ${props => !props.hoverState && css`
        cursor: default;
    `}

   
    .menu-link  {
        font-size: ${props => props.theme.font.size.base};
        font-family: ${props => props.theme.font.family.bold};
        text-transform: uppercase;
        text-decoration: none;
        color: ${props => props.theme.colors.purple};
        display: block;
        padding-bottom: .5rem;
        margin-top: .5rem;
    }
    

    &:hover {
        .hoverBg {
            opacity: 1;
        }
    }
`

const ImageWrap = styled.div`
    position: relative;
    margin-bottom: 1rem;
`

const ColStyled = styled(Col)`
    a {
        font-size: 1.5rem;
        padding-right: 1.5rem;
    }
`

const Close = styled.button`
	background: transparent;
	border: 0;
	position: fixed;
	z-index: 1;
	right: 2rem;
	top: 1rem;
	display: block;
	color: ${props => props.theme.colors.black};
    font-size: 1.5rem;

    @media ${media.sm} {
        right: .5rem;
	    top: .5rem;
        position: absolute;
    }

    @media ${media.md} {
        right: -.5rem;
	    top: -.75rem;
    }
    /* @media ${media.lg} {
        right: -1rem;
	    top: -1.5rem;
    } */
`

const MenuModal = styled(Modal)`
    @media ${media.md} {
        display: flex; 
        align-items: center;
        min-height: calc(100% - 3.5rem);
    }
    
    .modal-content {
        padding: 1rem;
        font-size: ${props => props.theme.font.size.base};

        h4 {
            font-family: ${props => props.theme.font.family.black};
            font-weight: ${props => props.theme.font.weight.black};
            font-size: ${props => props.theme.font.size.xl};
        }
    }
`

class MenuListingItem extends Component {
    constructor(props) {
        super(props)

        this.state = {
            active: false,
            modal: false
        }

        this.checkModalUrl = this.checkModalUrl.bind(this)
        this.onClick = this.onClick.bind(this)
        this.toggleModal = this.toggleModal.bind(this)
    }

    componentDidMount() {
        this.checkModalUrl()
    }

    checkModalUrl() {
        const hash = typeof window !== "undefined" && window.location.hash.replace("#", "")
        // if we have hash in url and matched slug launch modal
        if(hash && hash === this.props.data.slug) {
            this.setState({
                modal: true
            })
        }
    }

    onClick(type) {
        if (type === "page") {
            // go to page
            navigate(this.props.data.uri)
        } else if (type === "popup") {
            // launch modal
            this.toggleModal()
        }
    }

    toggleModal(e) {
        e && e.stopPropagation()
        e && e.preventDefault()
        this.setState({
            modal: !this.state.modal
        })
    }

    toggleClass(id) {
        document.getElementById(id).classList.toggle("active")
    }

    render() {
        const { data, dishes } = this.props
        const { type } = data.acfTastePageSettings 
        const menuId = data.databaseId
        const { image } = data.acfMenu 
        let hoverState = type === "none" ? false : true

        return(
            <>
                <ListingItemStyled 
                    hoverState={hoverState}
                >
                    {image && (
                        <ImageWrap onClick={(e) => this.onClick(type)}>
                            <GatsbyImage
                                image={image.localFile.childImageSharp.gatsbyImageData}
                                alt={image.altText}
                                loading="eager"
                            />
                            {hoverState &&
                                <CarouselItemBg 
                                    className="hoverBg" 
                                    borderOnHover={false}
                                    type="menu"
                                >
                                    <div>View Menu</div>
                                </CarouselItemBg>
                            }
                        </ImageWrap>
                    )}
                    <div className="content">
                        <MenuDishes 
                            title={data.title} 
                            dishes={dishes} 
                            menuId={menuId}
                            size="sm"
                        />
                        {data.acfTastePageSettings.type === "popup" &&
                            <a href="#" onClick={this.toggleModal} className="menu-link pt-3">
                                <span>View Menu</span>
                            </a> 
                        }
                        {data.acfTastePageSettings.type === "page" &&
                            <WPLink url={data.uri} className="menu-link pt-3">
                                <span>View Menu</span>
                            </WPLink>
                        }
                    </div>
                </ListingItemStyled>

                {data.acfTastePageSettings.type === "popup" && this.state.modal &&
                    <MenuModal isOpen={this.state.modal} toggle={this.toggleModal} size="lg">
                        <ModalBody>
                            <Close onClick={this.toggleModal}>
                                <FontAwesomeIcon icon={faTimes} />
                                <span className="sr-only">Close</span>
                            </Close>
                            <Row>
                                <Col md={4} className="d-none d-lg-block">
                                    <GatsbyImage
                                        image={data.acfTastePageSettings.featuredImage45.localFile.childImageSharp.gatsbyImageData}
                                        alt={data.acfTastePageSettings.featuredImage45.altText}
                                        loading="eager"  
                                    /> 
                                </Col>
                                <Col xs={12} lg={8}>
                                    {data.acfTastePageSettings.popupTitle &&
                                        <Text as="h4" primary uppercase>{data.acfTastePageSettings.popupTitle}</Text>
                                    }
                                    {data.acfTastePageSettings.popupText &&
                                        <Text base dangerouslySetInnerHTML={{ __html: data.acfTastePageSettings.popupText }} />
                                    }
                                    <Row className="align-items-center">
                                        {data.acfTastePageSettings.popupCtaLink &&
                                            <Col md="auto" className="pb-3 pb-lg-0">
                                                <WPLink 
                                                    url={data.acfTastePageSettings.popupCtaLink.url} 
                                                    button 
                                                    color="black" 
                                                    target={data.acfTastePageSettings.popupCtaLink.target}
                                                >
                                                    {data.acfTastePageSettings.popupCtaLink.title}
                                                </WPLink>
                                            </Col>
                                        }
                                        <ColStyled md="auto">
                                            {data.acfTastePageSettings.popupFacebook && 
                                                <a href={data.acfTastePageSettings.popupFacebook} target="_blank" rel="noopener noreferrer">
                                                    <span className="sr-only">Facebook</span>
                                                    <FontAwesomeIcon icon={faFacebookF} />
                                                </a>
                                            }
                                            {data.acfTastePageSettings.popupTwitter && 
                                                <a href={data.acfTastePageSettings.popupTwitter} target="_blank" rel="noopener noreferrer">
                                                    <span className="sr-only">Twitter</span>
                                                    <FontAwesomeIcon icon={faTwitter} />
                                                </a>
                                            }
                                            {data.acfTastePageSettings.popupInstagram && 
                                                <a href={data.acfTastePageSettings.popupInstagram} target="_blank" rel="noopener noreferrer">
                                                    <span className="sr-only">Instagram</span>
                                                    <FontAwesomeIcon icon={faInstagram} />
                                                </a>
                                            }
                                            {data.acfTastePageSettings.popupWebsiteLink && 
                                                <WPLink url={data.acfTastePageSettings.popupWebsiteLink} target="_blank" rel="noopener noreferrer">
                                                    <span className="sr-only">Website</span>
                                                    <FontAwesomeIcon icon={faGlobe} />
                                                </WPLink>
                                            }
                                        </ColStyled>
                                    </Row>
                                </Col>
                            </Row>
                        </ModalBody>
                    </MenuModal>
                }
            </>
        ) 
    }
}

export default MenuListingItem